import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../../../actions/API_endpoint";

const ManageGalleries = () => {
  const [galleries, setGalleries] = useState([]);

  useEffect(() => {
    fetchGalleries();
  }, []);

  const fetchGalleries = async () => {
    try {
      const response = await axios.get(`${Base_URL}/api/galleries`);
      if (response.data.success) {
        setGalleries(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching galleries:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this gallery?")) {
      try {
        await axios.delete(`${Base_URL}/api/galleries/${id}`);
        fetchGalleries();
      } catch (error) {
        console.error("Error deleting gallery:", error);
      }
    }
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white/5 backdrop-blur-2xl border border-white/20 text-white">
            <div className="rounded-t mb-0 px-4 py-3 border-0 border-b border-white/20">
              <div className="flex flex-wrap items-center">
                <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 className="font-semibold text-lg text-white">
                    Manage Galleries
                  </h3>
                </div>
                <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                  <Link
                    to="/admin/createGallery"
                    className="bg-lightBlue-600 text-white active:bg-lightBlue-700 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 border border-white/20 hover:bg-lightBlue-500"
                  >
                    Create New
                  </Link>
                </div>
              </div>
            </div>
            <div className="block w-full overflow-x-auto">
              <table className="items-center w-full bg-transparent border-collapse">
                <thead>
                  <tr>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-white/10 text-white border-white/20">
                      Name
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-white/10 text-white border-white/20">
                      Description
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-white/10 text-white border-white/20">
                      Images
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-white/10 text-white border-white/20">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {galleries.map((gallery) => (
                    <tr key={gallery.id}>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left font-bold text-white border-white/10">
                        {gallery.name}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-white/10">
                        {gallery.description}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-white/10">
                        {gallery.images?.length || 0}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-white/10">
                        <Link
                          to={`/admin/gallery/${gallery.id}/images`}
                          className="text-white bg-lightBlue-500 hover:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 border border-white/20"
                        >
                          Manage Images
                        </Link>
                        <button
                          onClick={() => handleDelete(gallery.id)}
                          className="text-white bg-red-500 hover:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 border border-white/20"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageGalleries;
